// Persist dark-mode preference across refreshes and pages (P2-02).
// Reads from localStorage; if unset, falls back to the OS preference.
const STORAGE_KEY = 'mid2bid.theme';

export const getStoredTheme = () => {
  if (typeof window === 'undefined') return 'light';
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === 'dark' || stored === 'light') return stored;
  } catch (_) {
    /* ignore */
  }
  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }
  return 'light';
};

export const applyTheme = (theme) => {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  if (theme === 'dark') {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }
  try {
    window.localStorage.setItem(STORAGE_KEY, theme);
  } catch (_) {
    /* ignore */
  }
};

export const toggleTheme = () => {
  const next = document.documentElement.classList.contains('dark') ? 'light' : 'dark';
  applyTheme(next);
  return next;
};

// Apply immediately on module load so the very first paint is correct.
if (typeof window !== 'undefined') {
  applyTheme(getStoredTheme());
}
